
export const ArrowUp = ({ width = 11, height = 6 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.666 5.5L5.66602 0.5L0.666016 5.5L10.666 5.5Z" fill="#666666" />
        </svg>
    )
}
